/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentRunsStreamAgentRunEvents } from "../../funcs/agentRunsStreamAgentRunEvents.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.StreamAgentRunEventsRequest$inboundSchema,
};

export const tool$agentRunsStreamAgentRunEvents: ToolDefinition<typeof args> = {
  name: "agent-runs-stream-agent-run-events",
  description: `Stream agent run events

Streams Server-Sent Events for the gateway response linked to this agent run. Terminal runs emit a single terminal event and close.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentRunsStreamAgentRunEvents(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
